/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BookmarksWidgetContainer_widget$ref = any;
type ClockWidgetContainer_widget$ref = any;
type NotesWidgetContainer_widget$ref = any;
type SearchWidgetContainer_widget$ref = any;
type TodosWidgetContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetContainer_widget$ref: FragmentReference;
declare export opaque type WidgetContainer_widget$fragmentType: WidgetContainer_widget$ref;
export type WidgetContainer_widget = {|
  +type: ?string,
  +$fragmentRefs: BookmarksWidgetContainer_widget$ref & SearchWidgetContainer_widget$ref & ClockWidgetContainer_widget$ref & NotesWidgetContainer_widget$ref & TodosWidgetContainer_widget$ref,
  +$refType: WidgetContainer_widget$ref,
|};
export type WidgetContainer_widget$data = WidgetContainer_widget;
export type WidgetContainer_widget$key = {
  +$data?: WidgetContainer_widget$data,
  +$fragmentRefs: WidgetContainer_widget$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BookmarksWidgetContainer_widget",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchWidgetContainer_widget",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ClockWidgetContainer_widget",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "NotesWidgetContainer_widget",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TodosWidgetContainer_widget",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '219df5ac5e2f6c46fa93156450c20d14';
module.exports = node;
